import React from 'react'
import mainBG from '../../../assets/EinführungMainBG.png'
import ellipseBG from '../../../assets/EllipseBG.png'
import { useFormik } from 'formik';
import { useTranslation } from "react-i18next";

const validate = values => {
    const errors = {};
    if (!values.fatherPlaceOfBirth) {
        errors.fatherPlaceOfBirth = `Father's place of birth is required`;
    }
    if (!values.motherPlaceOfBirth) {
        errors.motherPlaceOfBirth = `Mother's place of birth is required`;
    }
    if (!values.placeOfBirth) {
        errors.placeOfBirth = 'Place Of Birth is required';
    }
    return errors;
};

const InputForm = ({ nextClick, backClick, formik }) => {
    const { t } = useTranslation();
    return (
        <div style={{ background: `url(${mainBG})` }} className='h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between'>
            <div></div>
            <div style={{ background: `url(${ellipseBG})` }} className='min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative'>
                <div className='relative h-full mx-auto w-full max-w-[36rem] text-center pb-4 px-6 sm:px-0'>
                    <div className='h-full'>
                        <div className='flex flex-col justify-between h-full pt-20 items-center'>

                            {/* Form Container */}
                            <div className='w-full max-w-[32rem] sm:max-w-[36rem]'>
                                
                                {/* Father's Place of Birth */}
                                <div className='mb-6 text-left'>
                                    <label className='text-white font-medium mb-2 block'>{t(`s-7-label1`)}</label>
                                    <input
                                        type='text'
                                        name="fatherPlaceOfBirth"
                                        className='simurg_input w-full'
                                        value={formik.values.fatherPlaceOfBirth}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.fatherPlaceOfBirth && formik.errors.fatherPlaceOfBirth && (
                                        <div className="text-red-500 text-sm mt-1">{formik.errors.fatherPlaceOfBirth}</div>
                                    )}
                                </div>

                                {/* Mother's Place of Birth */}
                                <div className='mb-6 text-left'>
                                    <label className='text-white font-medium mb-2 block'>{t(`s-7-label2`)}</label>
                                    <input
                                        type='text'
                                        name='motherPlaceOfBirth'
                                        className='simurg_input w-full'
                                        value={formik.values.motherPlaceOfBirth}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.motherPlaceOfBirth && formik.errors.motherPlaceOfBirth && (
                                        <div className="text-red-500 text-sm mt-1">{formik.errors.motherPlaceOfBirth}</div>
                                    )}
                                </div>

                                {/* Place of Birth */}
                                <div className='mb-6 text-left'>
                                    <label className='text-white font-medium mb-2 block'>{t(`s-7-label3`)}</label>
                                    <input
                                        type='text'
                                        name='placeOfBirth'
                                        className='simurg_input w-full'
                                        value={formik.values.placeOfBirth}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.placeOfBirth && formik.errors.placeOfBirth && (
                                        <div className="text-red-500 text-sm mt-1">{formik.errors.placeOfBirth}</div>
                                    )}
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className='flex gap-6 w-full max-w-[32rem] sm:max-w-[36rem] flex-col-reverse sm:flex-row'>
                                <button className='w-full button_primary' onClick={backClick}>{t(`s-2-btn1`)}</button>
                                <button className='w-full button_secodry' onClick={nextClick}>{t(`s-2-btn2`)}</button>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InputForm;
